var templates = {
  auto: "var(--chakra-transform)",
  "auto-gpu": "var(--chakra-transform-gpu)"
};
export var transform = {
  transform: {
    property: "transform",

    transform(value) {
      var _templates$value;

      return (_templates$value = templates[value]) != null ? _templates$value : value;
    }

  },
  transformOrigin: true
};
//# sourceMappingURL=transform.js.map